import { Injectable, inject } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ChangesStatusService } from '../_services/changes-status.service';

@Injectable()
export class StatusChangesGuard {
  private changeStatusService = inject(ChangesStatusService);

  canDeactivate(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.changeStatusService.confirmDialog();
  }
}

export interface EditableComponent {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}
